(() => {
  'use strict';
  const root = document.getElementById('MainContent');
  if (!root) return;
  const clean = value => (value || '').replace(/\s+/g, ' ').trim();
  let scheduled = false;
  const update = () => {
    scheduled = false;
    for (const link of root.querySelectorAll('.jdgm-rev__pic-link')) {
      if (clean(link.getAttribute('aria-label')) || clean(link.getAttribute('aria-labelledby'))) continue;
      const alt = clean(link.querySelector('img')?.getAttribute('alt'));
      link.setAttribute('aria-label', alt && !/^user picture$/i.test(alt) ? `View review photo: ${alt}` : 'View photo from this review');
    }
    for (const link of root.querySelectorAll('.jdgm-medal, .govx-id-cta button[aria-label]')) {
      const label = clean(link.getAttribute('aria-label'));
      const visibleText = clean(link.textContent);
      if (label && visibleText && !label.toLowerCase().includes(visibleText.toLowerCase())) {
        link.setAttribute('aria-label', `${label} — ${visibleText}`);
      }
    }
    for (const image of root.querySelectorAll('.jdgm-verified-badge__image img')) {
      if (!image.hasAttribute('alt')) image.setAttribute('alt', 'Judge.me verified reviews badge');
    }
    for (const input of root.querySelectorAll('.simplee_member_list_row input[type="radio"][name="selling_plan"]')) {
      if (input.labels?.length || input.getAttribute('aria-labelledby')) continue;
      if (input.getAttribute('aria-label') && !input.hasAttribute('data-dope-plan-label')) continue;
      const row = input.closest('.simplee_member_list_row');
      const label = clean([...row.querySelectorAll('.simplee_title_wrap h2, .simplee_title_wrap h3')].map(e => e.textContent).join(' '));
      if (label && input.getAttribute('aria-label') !== label) {
        input.setAttribute('data-dope-plan-label', 'true');
        input.setAttribute('aria-label', label);
      }
    }
    for (const star of root.querySelectorAll('.jdgm-form-dynamic__rating a.jdgm-star:not([href])')) {
      if (!star.hasAttribute('role')) star.setAttribute('role', 'button');
      if (!star.hasAttribute('tabindex')) star.setAttribute('tabindex', '0');
      const rating = Number(star.getAttribute('data-alt'));
      if (!star.hasAttribute('aria-label') && Number.isInteger(rating) && rating >= 1 && rating <= 5) {
        star.setAttribute('aria-label', `Rate ${rating} out of 5 stars`);
      }
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  new MutationObserver(schedule).observe(root, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ['alt', 'aria-hidden', 'aria-label'],
  });
  root.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const star = event.target.closest?.('.jdgm-form-dynamic__rating a.jdgm-star[role="button"]');
    if (!star) return;
    event.preventDefault();
    star.click();
  });
  schedule();
})();
